





















































import {Component, Prop, Vue} from "vue-property-decorator";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "LadingCodeA7Print"
})
export default class extends mixins(CommonMixin) {
    @Prop({ type: String, required: true }) readonly ladingCode!: string;

    get freightServices() {
        return Object.values(FreightServiceStore.data);
    }

    created() {
        if (!FreightServiceStore.ids.length) {
            FreightServiceStore.listFreightService({ params: new FreightServiceParams() });
        }
    }
}
